import React from "react";
import styled from "styled-components/macro";

import {
    LEGEND_STATUSES,
    MONTHS,
    MONTH_DIMMED_COLOR,
    MONTH_STATUS_DETAILS,
} from "./constants";
import { StatusSwatch } from "./index.style";

/**
 * 12 pastilles (janvier → décembre)
 * @param {{ months: string[], highlight?: string[] }} props - highlight : statuts du filtre État, les autres mois sont grisés
 */
export const MonthStatusBar = ({ months = [], highlight = [] }) => (
    <Bar>
        {months.map((month_status, index) => {
            const details = MONTH_STATUS_DETAILS[month_status];
            const isHit = !highlight.length || highlight.includes(month_status);
            return (
                <StatusSwatch
                    key={index}
                    $height={18}
                    $color={isHit ? details?.color : MONTH_DIMMED_COLOR}
                    title={`${MONTHS[index]} · ${details?.label ?? ""}`}
                />
            );
        })}
    </Bar>
);

export const MonthStatusLegend = () => (
    <Legend>
        {LEGEND_STATUSES.map((month_status) => (
            <LegendItem key={month_status}>
                <StatusSwatch
                    $color={MONTH_STATUS_DETAILS[month_status].color}
                />
                {MONTH_STATUS_DETAILS[month_status].label}
            </LegendItem>
        ))}
    </Legend>
);

const Bar = styled.div`
    display: flex;
    gap: 2px;
`;

const Legend = styled.div`
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    font-size: 12px;
    color: #616161;
`;

const LegendItem = styled.span`
    display: flex;
    align-items: center;
    gap: 6px;
`;
